<template>
  <div>
    <load v-if="loading"
          message="Carregando informações da família"/>
    <table
        class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
        v-else
    >
      <tbody>
      <tr>
        <td colspan="4">
          <h5 class="text-center"><b>REFERENCIAMENTOS</b></h5>
        </td>
      </tr>
      <tr>
        <td colspan="4">

          <ul v-for="(ref , index) in item.referenciamentos"
              :key="ref.id">
            <li>
              {{ ref.unidade }} - {{ ref.cadastro }}
            </li>
          </ul>
        </td>
      </tr>
      <tr>
        <th colspan="4">
          <h5 class="text-center"><b>ENDEREÇO</b></h5>
        </th>
      </tr>
      <tr>
        <td colspan="4">
          Logradouro:
          <strong>
            {{ item.endereco.logradouro.tipo }}
            {{ item.endereco.logradouro.nome_logradouro }}
          </strong>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          Número:
          <strong>{{ item.endereco.numero_endereco }}</strong>
        </td>
        <td colspan="2">
          Bairro/Localidade:
          <strong>
            {{
              item.endereco.localidade ? item.endereco.localidade.nome_localidade : ""
            }}</strong
          >
        </td>
      </tr>
      <tr>
        <td colspan="2">
          CEP:
          <strong>{{ item.endereco.logradouro.cep }}</strong>
        </td>
        <td colspan="2">
          Complemento:
          <strong>
            {{ item.endereco.complemento_endereco }}
          </strong>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          Ponto de Referência:
          <strong>
            {{ item.endereco.referencia_endereco }}
          </strong>
        </td>
        <td colspan="2">
          Endereço de Acolhimento institucional?
          <strong v-if="item.endereco.abrigo"> SIM </strong>
          <strong v-else> NÃO </strong>
        </td>
      </tr>

      <tr>
        <th colspan="4">
          <h5 class="text-center"><b>CONTATO</b></h5>
        </th>
      </tr>

      <tr>
        <td colspan="2">
          Telefone Um <b>{{ item.contatos.telefone_um }}</b>
        </td>
        <td colspan="1">
          Tipo do Telefone Um
          <b v-if="item.contatos.telefone_um_tipo">{{
              $root.arrays.tipo_contato_telefone.filter(
                  (e) => e.id == item.contatos.telefone_um_tipo
              )[0]["value"]
            }}</b>
        </td>
        <td colspan="1">
          Permite o envio de SMS?
          <b>{{ item.contatos.telefone_um_sms ? "SIM" : "NÃO" }}</b>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          Telefone Dois <b>{{ item.contatos.telefone_dois }}</b>
        </td>
        <td colspan="1">
          Tipo do Telefone Dois
          <b v-if="item.contatos.telefone_dois_tipo">{{
              $root.arrays.tipo_contato_telefone.filter(
                  (e) => e.id == item.contatos.telefone_dois_tipo
              )[0]["value"]
            }}</b>
        </td>
        <td colspan="1">
          Permite o envio de SMS?
          <b>{{ item.contatos.telefone_dois_sms ? "SIM" : "NÃO" }}</b>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          Telefone Três <b>{{ item.contatos.telefone_tres }}</b>
        </td>
        <td colspan="1">
          Tipo do Telefone Três
          <b v-if="item.contatos.telefone_tres_tipo">{{
              $root.arrays.tipo_contato_telefone.filter(
                  (e) => e.id == item.contatos.telefone_tres_tipo
              )[0]["value"]
            }}</b>
        </td>
        <td colspan="1">
          Permite o envio de SMS?
          <b>{{ item.contatos.telefone_tres_sms ? "SIM" : "NÃO" }}</b>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          Telefone Quatro <b>{{ item.contatos.telefone_quatro }}</b>
        </td>
        <td colspan="1">
          Tipo do Telefone Quatro
          <b v-if="item.contatos.telefone_quatro_tipo">{{
              $root.arrays.tipo_contato_telefone.filter(
                  (e) => e.id == item.contatos.telefone_quatro_tipo
              )[0]["value"]
            }}</b>
        </td>
        <td colspan="1">
          Permite o envio de SMS?
          <b>{{ item.contatos.telefone_quatro_sms ? "SIM" : "NÃO" }}</b>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          E-mail <b>{{ item.contatos.email }}</b>
        </td>
        <td colspan="1">
          Tipo do E-mail
          <b v-if="item.contatos.telefone_dois_tipo">{{
              $root.arrays.tipo_contato_email.filter(
                  (e) => e.id == item.contatos.email_tipo
              )[0]["value"]
            }}</b>
        </td>
        <td colspan="1">
          Permite o envio de notificações via e-mail?
          <b>{{ item.contatos.email_envio ? "SIM" : "NÃO" }}</b>
        </td>
      </tr>
      <tr>
        <th colspan="4">
          <h5 class="text-center"><b>ANIMAIS DE ESTIMAÇÃO</b></h5>
        </th>
      </tr>
      <tr>
        <td colspan="4">
          <AnimaisEstimacao :item="item.animais"/>
        </td>
      </tr>
      <tr>
        <th colspan="4">
          <h5 class="text-center"><b>MAIS INFORMAÇÕES</b></h5>
        </th>
      </tr>
      <tr>
        <td colspan="4">
          <MaisInfo :item="item"
                    :loading="loading"/>
        </td>
      </tr>

      <tr>
        <th colspan="4">
          <h5 class="text-center">
            <b>Forma de ingresso na unidade e motivo do primeiro atendimento</b>
          </h5>
        </th>
      </tr>
      <tr>
        <td colspan="4">
          <FormaIngresso :item="item.ingresso"
                         :loading="loading"/>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import AnimaisEstimacao from "./includes/AnimaisEstimacao.vue";
import MaisInfo from "./includes/MaisInfo.vue";
import FormaIngresso from "./includes/FormaIngresso.vue";

export default {
  props: ["item", "loading"],
  components: {
    AnimaisEstimacao,
    MaisInfo,
    FormaIngresso,
  },
};
</script>

<style>
tr {
  min-width: 100%;
  width: 100%;
}
</style>
